import { atom, createStore } from "jotai";
import { SectionsList, SelectedSection } from "./components/MainPage/NotWorkArea(Side&Head)/SideBar/SideBarInterface";
import { defaultConfig } from "./components/MainPage/Tools/Consts";
import { ConfigLk, ConfigSmeta, getOptionsForUser, updateOptionsForUser } from "./components/Url";
import { setActiveSection } from "./components/MainPage/Tools/Tools";
import { makeCallBacks } from "./components/MainPage/NotWorkArea(Side&Head)/Header/Header";
export const smetaStore = createStore();

//backgroundprocessing
//bg процесс это отдельная секция, в которой идет отображение загрузки формирования отчёта
const selectedProcessAtom = atom<string>(""); // выбранный bg process
const listOfProcessesAtom = atom([]); // список всех bg процессов

export { selectedProcessAtom, listOfProcessesAtom };

//sidebar data
const selectedSectionAtom = atom<SelectedSection>({
  //данные о текущей выбранной секции
  ID: "",
  CLSID: "",
  Name: "",
  Image: "",
});
const sectionListAtom = atom<SectionsList[]>([]); // массив всех секций
const pushNewSectionAtom = atom(null, (get, set, newValue: SectionsList) => {
  //функция для добавления новой секции в массив секций
  const sections = get(sectionListAtom);
  const newSections = sections.concat(newValue);
  set(sectionListAtom, newSections);
});
const setSelectedSectionAtom = atom(null, (get, set, newValue: SelectedSection) => {
  //функция для изменения текущей выбранной секции
  makeCallBacks().then((callBacksResp) => {
    if (!callBacksResp) return;
    if (newValue.ID) {
      document.title = newValue.Name;
      updateOptionsForUser({
        ID: newValue.ID,
        CLSID: newValue.CLSID,
        Name: newValue.Name,
      });
    }
    set(selectedSectionAtom, newValue);
    setActiveSection(newValue.ID);
  });
});

export { selectedSectionAtom, sectionListAtom, setSelectedSectionAtom, pushNewSectionAtom };

//theme slice
const userOptions = getOptionsForUser(); //опции для юзера, по конфигурации -> пользователю -> рабочему месту
const ipAtom = atom<string | null>(userOptions?.IP || null); // сервер перенаправления, для картинок и некоторых запросов
const pingIntervalAtom = atom<NodeJS.Timeout | null>(null);
const pingMinsAtom = atom(300000); //интервал времени когда посылать пинги на сервер
const redirectServer = atom(userOptions?.IP); // сервер перенаправления для получения ресурсов
const currentTheme = atom<string>(userOptions?.theme || "light"); //текущая выбранная тема
const animationsAtom = atom<boolean>(userOptions?.animations || false); //вкл ли анимации
const refreshSectionDataAtom = atom<{ refresh: boolean; refreshId: string; CommitFormOnSection: string } | null>(null);
const workPlaceToolsAtom = atom(undefined); //кнопки для рабочего места, запрашиваются 1 раз за обновление страницы
const imagesAtom = atom([]); // объект путями до картинки на сервере
const unloadCallbacksAtom = atom<{ [key: string]: Promise<void> }>({}); // колбэки которые надо при определнных условиях выполнить(смена секции, открытие/закрытие модалки, перезагрузка страницы)
const clearUnloadCallBack = atom(null, (get, set, newValue: string) => {
  //удаляем колбэк по ключу
  const callBacks = get(unloadCallbacksAtom);
  const newCallBacks = { ...callBacks };
  delete newCallBacks[newValue];
  set(unloadCallbacksAtom, newCallBacks);
});
const setUnloadCallbacksAtom = atom(null, (get, set, newValue: object) => {
  //добавляем новый коллбэк
  const [value] = Object.values(newValue);
  if (typeof value !== "function") return;
  const callBacks = get(unloadCallbacksAtom);
  const newCallBacks = { ...callBacks, ...newValue };
  set(unloadCallbacksAtom, newCallBacks);
});

export {
  currentTheme,
  animationsAtom,
  refreshSectionDataAtom,
  pingIntervalAtom,
  pingMinsAtom,
  redirectServer,
  workPlaceToolsAtom,
  imagesAtom,
  unloadCallbacksAtom,
  setUnloadCallbacksAtom,
  ipAtom,
  clearUnloadCallBack,
};

export const isAuthorized = atom(false);
export const headFormAtom = atom({});
export const hasStartPageAtom = atom(false);
export const appConfig = atom<{ smeta: ConfigSmeta; lk: ConfigLk }>({ ...defaultConfig });
//salary
export const renderingIdAtom = atom({ renderingId: 0, personId: 0 });
export const groupIdAtom = atom(0);
export const salaryRangeAtom = atom({ year: "", month: "", range: "0" });
export const leavesOpenAtom = atom(false);
export const isAdminAtom = atom<boolean>(userOptions?.isAdmin);
export const isSuperUserAtom = atom<boolean>(userOptions?.isSuperUser);
export const isOrgEnterAtom = atom<boolean>(userOptions?.isOrg);
export const configEnabledAtom = atom<boolean>(userOptions?.configEnabled);
export const personsTableCurrentId = atom(null);
export const helpContextAtom = atom<string | undefined>(userOptions?.helpContext);
export const sectionPersonsData = atom({});
export const userRightsAtom = atom<{ [key: string | number]: string }>({});
export const gridSelectedRecordColorAtom = atom<boolean>(userOptions?.gridSelectedRecordColor || false);
export const hideToastNotificationsAtom = atom<boolean>(userOptions?.hideToastNotifications || false);
export const editorCash = atom({
  detailsOpen: false,
});
